import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Container} from './styles';
import Settings from '../../assets/emojis/settings/settings@3x.png';
import Entrega from '../../assets/emojis/entrega/entrega@3x.png';
import Relogio from '../../assets/emojis/relogio/relogio@3x.png'
import Empresa from '../../assets/emojis/empresa/empresa@3x.png'
import Dollar from '../../assets/emojis/dollar/dollar@3x.png'

export default class Config extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carregou: true,
        }
    }

    render() {
        return(
            <Container>
            
            {this.state.carregou ?
            <div className="div-pai">
                <div className="div-rota"> 

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes'}>
                    <span>
                        Configurações
                    </span>
                </Link>

                </div>

                <img alt="" className="emoji" src={Settings} />
                
                <h1>Configurações</h1>

                <h5>Configure o seu restaurante da sua maneira.</h5>

                <div className="pages">
                    <div className="page" onClick={() => this.props.history.push('/configuracoes/entrega')}>
                        <img alt="" className="emoji" src={Entrega} />
                        <h4>Entrega</h4>
                        <h5>Configure as taxas <p>de entrega do seu restaurante.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                Ver mais
                            </button>
                        </div>
                    </div>
                    <div className="page" onClick={() => this.props.history.push('/configuracoes/formas-de-pagamento')}>
                        <img alt="" className="emoji" src={Dollar} />
                        <h4>Formas de pagamento</h4>
                        <h5>Configure as formas de pagamento <p>pelo app e na hora da entrega.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                Ver mais
                            </button>
                        </div>
                    </div>
                    <div className="page" onClick={() => this.props.history.push('/configuracoes/meu-restaurante')}>
                        <img alt="" className="emoji" src={Empresa} />
                        <h4>Meu restaurante</h4>
                        <h5>Configure como o seu perfil <p>será exibido no aplicativo appedidos.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                Ver mais
                            </button>
                        </div>
                    </div>
                    <div className="page" onClick={() => this.props.history.push('/configuracoes/horarios-de-funcionamento')}>
                        <img alt="" className="emoji" src={Relogio} />
                        <h4>Horários de funcionamento</h4>
                        <h5>Configure os dias que o seu restaurante <p>abre, turnos, dias fechados e feriados.</p></h5>
                        
                        <div className="botao">
                            <button className="salvar">
                                Ver mais
                            </button>
                        </div>
                    </div>
                    
                </div>

                <div style={{fontFamily: 'Montserrat', 
                    fontSize: 12, textAlign: 'left', color: '#a49b9b', marginLeft: 32, marginBottom: 24}}
                >
                    <text>Versão: 230824</text>
                </div>
            </div>
            :null}
            </Container>
        )
    }
}
